import React, { useRef, useState } from 'react'
import { Button, QRCode } from 'antd'
import styles from './QRCodeGenerator.module.css'
import { Modal } from 'antd'
import PersonalizeQRCode from '../PersonalizeQRCode/PersonalizeQRCode'

import { FundProjectionScreenOutlined } from '@ant-design/icons'

const QRCodeGenerator = ({ url }) => {
  const qrcodeRef = useRef(null)

  const [isPersonalizeQRCodeModalOpen, setIsPersonalizeQRCodeModalOpen] =
    useState(false)

  const personalizeQRCodeModal = () => {
    setIsPersonalizeQRCodeModalOpen(true)
  }

  const handleCancelPersonalizeQRCodeModal = () => {
    setIsPersonalizeQRCodeModalOpen(false)
  }

  const downloadQRCode = () => {
    const canvas = qrcodeRef.current?.querySelector('canvas')
    if (canvas) {
      const imgUrl = canvas.toDataURL()
      const a = document.createElement('a')
      a.download = 'QRCode.png'
      a.href = imgUrl
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  }

  return (
    <div>
      <Modal
        centered
        width={1200}
        title="Personnalisez votre page de QR Code !"
        open={isPersonalizeQRCodeModalOpen}
        onCancel={handleCancelPersonalizeQRCodeModal}
        maskClosable={true}
        footer={null}
      >
        <PersonalizeQRCode url={url} />
      </Modal>

      <div className={styles.qrcode_bloc}>
        <div ref={qrcodeRef}>
          <div className={styles.qr_code_content}>
            <QRCode value={url} bgColor="#fff" style={{}} />
          </div>

          <div className={styles.container_buttons}>
            <div
              className={styles.personnalize_btn__container}
              onClick={personalizeQRCodeModal}
            >
              <FundProjectionScreenOutlined />
              <span>&nbsp;&nbsp;Personnaliser</span>
            </div>

            <div className={styles.preview__container} onClick={downloadQRCode}>
              Télécharger
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default QRCodeGenerator
